import moment from 'moment'
import templateUrl from './payroll-invoice-dashboard-container.component.html'

export const PayrollInvoiceDashboardContainerComponent = {
    templateUrl,
    require: {
        dashboardContext: "^apexDashboardContent"
    },
    controller: class PayrollInvoiceDashboardContainer {
        constructor($q, payrollService, payrollInvoiceService, utilityService) {
            'ngInject'
            this.$q = $q
            this.payrollService = payrollService
            this.payrollInvoiceService = payrollInvoiceService
            this.utilityService = utilityService
            this.pageSize = 5
            this.pageIndex = 0
            this.loaded = false
            this.filters = {
                StartDate: moment().add(-1, "month").toDate(),
                EndDate: undefined
            }
        }

        $onInit() {
            this.dashboard = this.dashboardContext.dashboard

            this.loadPayrollInvoices()
                .then(() => {
                    if (this.dashboardContext) {
                        this.dashboardContext.activateDashboard({
                            visible: true,
                            count: this.page.TotalEntityCount
                        })
                    }
                })
                .catch(function (ex) {
                    console.error("Payroll invoice dashboard activation failed");
                    console.error(ex);
                })
                .then(() => {
                    this.loaded = true;
                });
        }

        loadPayrollInvoices() {

            const query = {
                Dismissed: false,
                PageSize: this.pageSize,
                StartDate: this.filters.StartDate ? moment(this.filters.StartDate).format("YYYY-MM-DD") : null,
                EndDate: undefined,
                ClientName: this.filters.ClientName,
                Owner: this.filters.Owner
            };
            return this.payrollInvoiceService.retrievePayrollInvoicesPage(this.pageIndex, query)
                .then((page) => {
                    page.Entities.forEach(this.hydratePayrollInvoices)
                    this.page = page;
                    return page;
                });
        }

        /**
         * Dismiss the given payroll invoice.
         * @param {any} invoice The invoice to be dismissed
         * @param {boolean} dismissed Boolean to dismiss or undo dismissal
         */
        onDismiss({ invoice, dismissed }) {
            invoice.IsDismissed = dismissed;
            this.payrollInvoiceService.updatePayrollInvoice(invoice.PayrollID, invoice)
                .then(function () {
                    invoice.isDismissed = dismissed;
                })
                .catch(function (ex) {
                    console.error(ex)
                    invoice.IsDismissed = invoice.isDismissed;
                });
        }

        onChangePage({ pageIndex }) {
            this.pageIndex = pageIndex
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(this.loadPayrollInvoices(), "Load failed"));
        }

        onChangeFilters() {
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(this.loadPayrollInvoices(), "Load failed"));
        }

        hydratePayrollInvoices(invoice) {
            invoice.isDismissed = invoice.IsDismissed
        }
    }
}
